import React, { useState, useEffect } from 'react';
import Prism from 'prismjs';

const CodeEditor = (props) => {
	const { content, setContent } = props;

	let sidebarScroll = React.createRef();
	let contentScroll = React.createRef();
	let _preventEvent = false;
	let contentLastScrollTop = 0;
	let contentLastScrollLeft = 0;

	const onSidebarScroll = (e) => {
		if (_preventEvent) {
			_preventEvent = false;
			return;
		}

		_preventEvent = true;
		contentScroll.current.scrollTop = e.target.scrollTop;
		contentScroll.current.scrollLeft = e.target.scrollLeft;
	};

	const onContentScroll = (e) => {
		if (_preventEvent) {
			_preventEvent = false;
			return;
		}

		if (e.target.scrollTop !== contentLastScrollTop) {
			_preventEvent = true;
			sidebarScroll.current.scrollTop = e.target.scrollTop;
			contentLastScrollTop = e.target.scrollTop;
		}
		if (e.target.scrollLeft !== contentLastScrollLeft) {
			_preventEvent = true;
			sidebarScroll.current.scrollLeft = e.target.scrollLeft;
			contentLastScrollLeft = e.target.scrollLeft;
		}
	};

	const handleKeyDown = async (evt) => {
		let value = content,
			selStartPos = evt.currentTarget.selectionStart;

		// handle 4-space indent on
		if (evt.key === 'Tab') {
			evt.persist();
			evt.preventDefault();
			value = value.substring(0, selStartPos) + '    ' + value.substring(selStartPos, value.length);
			await setContent(value);
			evt.target.selectionStart = selStartPos + 4;
			evt.target.selectionEnd = selStartPos + 4;
		}
	};

	useEffect(
		() => {
			Prism.highlightElement(contentScroll.current.querySelector('code'));
		},
		[content, contentScroll]
	);

	return (
		<div className="code-edit-container" style={props.style}>
			<textarea
				ref={sidebarScroll}
				onScroll={onSidebarScroll}
				className="code-input"
				value={content}
				disabled={props.disabled}
				onChange={(evt) => setContent(evt.target.value.replace(/	/g, '    '))}
				onKeyDown={handleKeyDown}
			/>
			<pre className={`code-output language-${props.language}`} ref={contentScroll} onScroll={onContentScroll}>
				<code className={`language-${props.language}`} >{content}</code>
			</pre>
		</div>
	);
};

export default CodeEditor;
